<script setup lang="ts">
import { CheckIcon, ChevronDownIcon } from '@gohighlevel/ghl-icons/24/outline'
import { UIDropdown } from '@gohighlevel/ghl-ui'
import { computed, h, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  filterOptions: {
    type: Array,
    required: true,
    default: () => [],
  },
  filterValue: {
    type: String,
    required: true,
    default: '',
  },
  placeholder: {
    type: String,
    required: true,
    default: '',
  },
  label: {
    type: String,
    required: true,
    default: '',
  },
  onChange: {
    type: Function,
    required: true,
    default: () => {},
  },
  filterKey: {
    type: String,
    required: true,
    default: 'tt',
  },
  id: {
    type: String,
    required: true,
  },
})

const showDropdown = ref(false)

const value = computed(() => {
  return props.filterValue
})

const handleFilterChange = (key: string) => {
  props.onChange(props.filterKey, key)
  showDropdown.value = !showDropdown.value
}

const selectedCalendarsLabel = computed(() => {
  const selectedOption: any = props.filterOptions.find(
    (option: any) => option.key === value.value
  )
  return selectedOption
    ? `${props.label}: ${selectedOption.label}`
    : props.label
})

const handleDropdownClick = () => {
  showDropdown.value = !showDropdown.value
}

const renderOption = (prop: any) => {
  const option = prop.option
  const isSelected = option.key === value.value
  return h(
    'div',
    {
      class: [
        'flex p-2 w-full cursor-pointer gap-1 truncate items-center justify-between',
        isSelected ? 'bg-gray-100 ' : 'bg-transparent',
      ],
      onClick: () => handleFilterChange(option.key),
    },
    [
      h(
        'span',
        {
          class: [
            'text-[14px] text-gray-700',
            isSelected ? 'text-primary-700' : '',
          ],
        },
        option.label // Corrected syntax for span content
      ),
      isSelected
        ? h(CheckIcon, {
            class: 'w-4 h-4 text-primary-700',
          })
        : null,
    ]
  )
}
</script>
<template>
  <div class="w-full">
    <UIDropdown
      :id="id"
      :options="filterOptions"
      placement="bottom-start"
      multiple="false"
      :show="showDropdown"
      size="small"
      :render-option="renderOption"
      @select="handleFilterChange"
      @update:show="handleDropdownClick"
    >
      <div id="btn" text="true" type="default">
        <div
          class="flex h-[36px] cursor-pointer items-center justify-between rounded-md border border-gray-300 px-[8px] py-[8px] font-normal text-gray-900 shadow-sm"
        >
          <span class="truncate text-[14px]">{{ selectedCalendarsLabel }}</span>
          <ChevronDownIcon
            class="ml-2 h-5 w-5 font-normal text-gray-300"
            :class="{
              'rotate-180': showDropdown,
            }"
          />
        </div>
      </div>
    </UIDropdown>
  </div>
</template>

<style>
#calendar-status-filter {
  width: 140px !important;
}
#calendar-type-filter {
  width: 180px !important;
}
#calendar-owned-by-filter {
  width: 180px !important;
}

#calendar-status-filter,
#calendar-type-filter,
#calendar-owned-by-filter {
  border-radius: 3px !important;
  border: none !important;
  line-height: 1.4rem !important;
}
</style>
